<template>
  <div v-if="value">
    <a
      ref="link"
      :href="value.url" target="_blank"
      class="text-reset partial-underline"
    >
      📍<span class="text">{{value.label}}</span>
    </a>
    <b-popover
      :target="() => $refs.link"
      triggers="hover"
    >
      <div style="width:300px" class="mw-100 embed-responsive embed-responsive-1by1">
        <div class="embed-responsive-item d-flex justify-content-center align-items-center">
          Loading map...
        </div>
        <iframe id="gmap_canvas"
          class="embed-responsive-item"
          :src="`${value.url}&t=&ie=UTF8&iwloc=&output=embed`"
          frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
        ></iframe>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: 'DisplayLocation',
  props: {
    value: Object,
  },
}
</script>
